import Image from 'next/image';

export const LeagueLogo = ({ size = 32 }: { size?: number }) => {
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      className={`w-[${size}px] h-[${size}px] rounded flex items-center justify-center`}
    >
      <Image src="/LEAGUE-256x256x32.png" width={size * 0.7} height={size * 0.7} alt="League of Legends" />
    </div>
  );
};
